import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Box, 
  LinearProgress, 
  Button, 
  Link, 
  Chip,
  Stack
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { getDownloadUrl, getProgressUrl } from '../services/api';

const QueueItem = ({ 
  item, 
  progressInfo, 
  calculateETA, 
  onPreview 
}) => {
  const {
    processedGroups = 0,
    totalGroups = 0,
    isCompleted = false,
    inQueue = true,
    lastUpdateTime = null,
    last_last_update = null,
    error: progressError = null
  } = progressInfo || {};

  const percentage = totalGroups > 0 ? (processedGroups / totalGroups) * 100 : 0;
  const eta = !isCompleted && !inQueue && totalGroups > 0
    ? calculateETA(processedGroups, totalGroups, lastUpdateTime, last_last_update)
    : null;

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="h6" component="div">
          {item.originalFilename || item.filename}
        </Typography>
        
        <Stack direction="row" spacing={1} sx={{ mb: 1.5 }}>
          <Chip label={`Operación: ${item.operation}`} size="small" />
          <Chip label={`Posición: ${item.position}`} size="small" />
        </Stack>

        {progressError && (
          <Chip 
            label={`Error: ${progressError}`} 
            color="error" 
            sx={{ mb: 1 }} 
          />
        )}

        {inQueue && !isCompleted && !progressError && (
          <Chip 
            label="En espera..." 
            color="info" 
            sx={{ mb: 1 }} 
          />
        )}

        {!inQueue && !isCompleted && totalGroups > 0 && !progressError && (
          <Box sx={{ width: '100%', mb: 1 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
              {`Procesando: Grupo ${processedGroups} de ${totalGroups}`}
            </Typography>
            
            <LinearProgress 
              variant="determinate" 
              value={percentage} 
              sx={{ height: 10, borderRadius: 5, mb: 0.5 }} 
            />
            
            <Typography variant="caption" display="block" gutterBottom>
              {`${percentage.toFixed(1)}% Completado`} 
              {eta ? ` | Tiempo restante: ${eta}` : ''}
            </Typography>
          </Box>
        )}

        {isCompleted && !progressError && (
          <Box>
            <Chip 
              label="¡Procesamiento completado!" 
              color="success" 
              sx={{ mb: 1.5 }} 
            />
            
            <Stack direction="row" spacing={1}>
              <Button
                variant="outlined"
                size="small"
                startIcon={<DownloadIcon />}
                href={getDownloadUrl(item.filename)}
                download
              >
                Descargar
              </Button>
              
              <Button
                variant="outlined"
                size="small"
                startIcon={<VisibilityIcon />}
                onClick={() => onPreview(item.filename)}
              >
                Vista Previa
              </Button>
            </Stack>
          </Box>
        )}

        <Link
          href={getProgressUrl(item.filename)}
          target="_blank"
          rel="noopener noreferrer"
          variant="caption"
          sx={{ mt: 1.5, display: 'block', fontSize: '0.7rem' }}
        >
          (Verificar Progreso)
        </Link>
      </CardContent>
    </Card>
  );
};

export default QueueItem; 